import { useContext } from "react";
import { map, compact, find } from "lodash-es";
import moment from "moment";
import { Line } from "react-chartjs-2";

import Graph from "@/common/Graph";
import Context from "@/layout/Context";

import helpers from "@/lib/helpers";

export default function HubPrepStats() {
  const { isDesktop } = useContext(Context);
  return (
    <Graph
      path="/reports/hub-prep"
      dataKey="stats"
      refetchInterval={120000}
      renderProps={({ averages }) => {
        const timeslots = compact(map(averages, (r) => r.time_of_day));
        const daysOfYearRepresented = [];

        const data = map(timeslots, (time_of_day) => {
          const datapoint = find(averages, { time_of_day });
          return datapoint
            ? Number(Math.round(datapoint.avg_minutes_to_completion))
            : 0;
        });
        const color = helpers.lineGraphColors.green;

        return (
          <div>
            {isDesktop && (
              <div className="u-flex u-flex-wrap">
                <div className="h4 u-text-center">
                  Average Time Until Hub Prepped
                </div>
                <Line
                  data={{
                    labels: map(timeslots, (r) => {
                      const dayOfYear = moment(r).dayOfYear();
                      if (!daysOfYearRepresented.includes(dayOfYear)) {
                        daysOfYearRepresented.push(dayOfYear);
                        return moment(r).format("ddd MM/DD hh:mm a");
                      } else {
                        return moment(r).format("MM/DD hh:mm a");
                      }
                    }),
                    datasets: [
                      {
                        fill: false,
                        label: "Minutes",
                        data,
                        lineTension: 0.1,
                        backgroundColor: color,
                        borderColor: color,
                        borderCapStyle: "butt",
                        borderDash: [],
                        borderDashOffset: 0.0,
                        borderJoinStyle: "miter",
                        pointBorderColor: helpers.lineGraphColors.darkGreen,
                        pointBackgroundColor: helpers.lineGraphColors.darkGreen,
                        pointBorderWidth: 1,
                        pointRadius: 1,
                        pointHitRadius: 10,
                        spanGaps: true,
                        showLine: true,
                      },
                    ],
                  }}
                  height={30}
                />
              </div>
            )}
          </div>
        );
      }}
    />
  );
}
